(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') {
    var boot = function () {
      document.querySelectorAll('[data-one-off-shop]').forEach(api.mount);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }
})(function () {
  'use strict';
  var keys = ['q', 'stringing', 'condition', 'brand', 'color', 'budget', 'available'];

  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  function matches(item, filters) {
    if (filters.available && !item.available) return false;
    if (filters.stringing && item.stringing !== filters.stringing) return false;
    if (filters.condition && item.condition !== filters.condition) return false;
    if (filters.brand && item.brand !== filters.brand) return false;
    if (filters.color && item.color !== filters.color) return false;
    if (filters.budget === 'under-50' && item.price >= 5000) return false;
    if (filters.budget === '50-100' && (item.price < 5000 || item.price > 10000)) return false;
    if (filters.budget === 'over-100' && item.price <= 10000) return false;
    var terms = normalize(filters.q).split(/\s+/).filter(Boolean);
    var haystack = normalize([item.title, item.brand, item.model, item.color].join(' '));
    return terms.every(function (term) { return haystack.indexOf(term) !== -1; });
  }

  // Keep sort, preview, locale and existing collection parameters when walking pages.
  function sectionURL(href, base, sectionId) {
    var original = new URL(base);
    var next = new URL(href, original);
    if (next.origin !== original.origin || next.pathname !== original.pathname) {
      throw new Error('Unexpected collection pagination destination');
    }
    original.hash = '';
    new Set(next.searchParams.keys()).forEach(function (key) { original.searchParams.delete(key); });
    next.searchParams.forEach(function (value, key) { original.searchParams.append(key, value); });
    original.searchParams.delete('sections');
    original.searchParams.set('section_id', sectionId);
    var page = Number(original.searchParams.get('page') || 1);
    if (!Number.isSafeInteger(page) || page < 1) throw new Error('Invalid page number');
    return original;
  }

  function completeCatalog(items, expectedTotal) {
    if (!Number.isSafeInteger(expectedTotal) || expectedTotal < 0 || items.length !== expectedTotal) return false;
    var ids = new Set();
    var positions = new Set();
    items.forEach(function (item) { ids.add(item.id); positions.add(item.sequence); });
    if (ids.size !== expectedTotal || positions.size !== expectedTotal) return false;
    for (var i = 0; i < expectedTotal; i += 1) if (!positions.has(i)) return false;
    return true;
  }

  function mount(root) {
    if (root.dataset.ooEnhanced === 'true') return;
    root.dataset.ooEnhanced = 'true';
    var grid = root.querySelector('[data-oo-grid]');
    var status = root.querySelector('[data-oo-status]');
    var filterPanel = root.querySelector('[data-oo-filters]');
    var fieldset = root.querySelector('[data-oo-fieldset]');
    var loadError = root.querySelector('[data-oo-load-error]');
    var retry = root.querySelector('[data-oo-retry]');
    var empty = root.querySelector('[data-oo-empty]');
    var pagination = root.querySelector('[data-oo-pagination]');
    var sortForm = root.querySelector('[data-oo-sort-form]');
    var sortSelect = root.querySelector('[data-oo-sort]');
    var controls = {};
    root.querySelectorAll('[data-oo-filter]').forEach(function (el) { controls[el.dataset.ooFilter] = el; });
    var initialURL = new URL(window.location.href);
    var sectionId = root.dataset.sectionId;
    var collectionHandle = root.dataset.collection;
    var pages = new Map();
    var items = [];
    var complete = false;
    var busy = false;
    var expectedTotal = null;

    function itemFromCard(card) {
      var data = card.dataset;
      var item = {
        id: data.productId,
        title: data.title || '', brand: data.brand || '', model: data.model || '',
        color: data.color || '', condition: data.condition || '', stringing: data.stringing || '',
        price: Number(data.price), available: data.available === 'true', sequence: Number(data.sequence),
        element: card
      };
      if (!item.id || !Number.isFinite(item.price) || item.price < 0 || !Number.isSafeInteger(item.sequence) || item.sequence < 0) {
        throw new Error('Invalid product data');
      }
      return item;
    }

    function readPage(section) {
      if (!section || section.dataset.collection !== collectionHandle) throw new Error('Missing collection section');
      var page = Number(section.dataset.page);
      var total = Number(section.dataset.total);
      if (!Number.isSafeInteger(page) || page < 1 || !Number.isSafeInteger(total) || total < 0) throw new Error('Invalid collection page');
      var next = section.querySelector('[data-oo-next]');
      return {
        number: page, total: total,
        cards: Array.from(section.querySelectorAll('[data-oo-card]')).map(itemFromCard),
        next: next ? next.getAttribute('href') : null
      };
    }

    function syncGrid() {
      var unique = new Map();
      pages.forEach(function (page) { page.cards.forEach(function (item) { unique.set(item.id, item); }); });
      items = Array.from(unique.values()).sort(function (a, b) { return a.sequence - b.sequence; });
      var fragment = document.createDocumentFragment();
      items.forEach(function (item) { fragment.appendChild(item.element); });
      grid.replaceChildren(fragment);
    }

    function getFilters() {
      var result = {};
      keys.forEach(function (key) { result[key] = key === 'available' ? controls[key].checked : controls[key].value; });
      return result;
    }

    function saveFilters() {
      var filters = getFilters();
      var url = new URL(window.location.href);
      keys.forEach(function (key) {
        var value = filters[key];
        if (value) url.searchParams.set('oo_' + key, key === 'available' ? '1' : value);
        else url.searchParams.delete('oo_' + key);
      });
      // The complete grid is visible, so reloading should start at the first native page.
      url.searchParams.delete('page');
      window.history.replaceState(window.history.state, '', url);
    }

    function render(save) {
      if (!complete) return;
      var filters = getFilters();
      var count = 0;
      items.forEach(function (item) {
        var show = matches(item, filters);
        item.element.hidden = !show;
        if (show) count += 1;
      });
      status.textContent = count + ' of ' + items.length + ' heads';
      empty.hidden = count !== 0;
      empty.querySelector('h2').textContent = items.length ? 'No heads match those filters.' : 'No heads are listed here right now.';
      empty.querySelector('p').textContent = items.length ? 'Try another color, a wider price range or fewer filters.' : 'Try one of the other head collections above.';
      empty.querySelector('button').hidden = items.length === 0;
      if (save) saveFilters();
    }

    function fillOptions(key, firstLabel) {
      var select = controls[key];
      select.replaceChildren(new Option(firstLabel, ''));
      Array.from(new Set(items.map(function (item) { return item[key]; }).filter(Boolean)))
        .sort(function (a, b) { return a.localeCompare(b); })
        .forEach(function (value) { select.add(new Option(value === 'Other' ? 'Other / unidentified' : value, value)); });
    }

    function enableFilters() {
      fillOptions('brand', 'All brands');
      fillOptions('color', 'All colors');
      keys.forEach(function (key) {
        var value = initialURL.searchParams.get('oo_' + key) || '';
        if (key === 'available') controls[key].checked = value === '1';
        else if (key === 'q') controls[key].value = value.slice(0, 120);
        else controls[key].value = Array.from(controls[key].options).some(function (option) { return option.value === value; }) ? value : '';
      });
      root.querySelector('[data-oo-brand-label]').hidden = controls.brand.options.length <= 2;
      fieldset.disabled = false;
      if (pagination) pagination.hidden = true;
      render(false);
    }

    async function fetchPage(url) {
      var controller = new AbortController();
      var timer = window.setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Collection page request failed');
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return readPage(doc.querySelector('[data-one-off-shop]'));
      } finally { window.clearTimeout(timer); }
    }

    async function loadAll(refresh) {
      if (busy) return;
      busy = true;
      complete = false;
      fieldset.disabled = true;
      retry.disabled = true;
      loadError.hidden = true;
      empty.hidden = true;
      root.setAttribute('aria-busy', 'true');
      status.textContent = 'Loading all heads so you can filter this collection…';
      if (refresh) { pages.clear(); expectedTotal = null; }
      try {
        var url = sectionURL(initialURL.toString(), initialURL.toString(), sectionId);
        url.searchParams.set('page', '1');
        var visited = new Set();
        while (url) {
          var number = Number(url.searchParams.get('page'));
          if (visited.has(number)) throw new Error('Pagination repeated a page');
          visited.add(number);
          var page = pages.get(number) || await fetchPage(url);
          if (page.number !== number) throw new Error('Unexpected page returned');
          if (expectedTotal === null) expectedTotal = page.total;
          if (page.total !== expectedTotal) throw new Error('Collection changed during loading');
          pages.set(number, page);
          syncGrid();
          status.textContent = items.length + ' heads loaded. Loading the rest before filtering…';
          if (page.next) {
            var nextURL = sectionURL(page.next, url.toString(), sectionId);
            if (Number(nextURL.searchParams.get('page')) <= number) throw new Error('Pagination did not advance');
            url = nextURL;
          } else url = null;
        }
        if (!completeCatalog(items, expectedTotal)) throw new Error('Incomplete collection');
        complete = true;
        enableFilters();
      } catch (error) {
        status.textContent = items.length + ' heads loaded. Collection filters are unavailable until all pages load.';
        loadError.hidden = false;
        if (pagination) pagination.hidden = false;
      } finally {
        busy = false;
        retry.disabled = false;
        root.setAttribute('aria-busy', 'false');
      }
    }

    try {
      var first = readPage(root);
      pages.set(first.number, first);
      expectedTotal = first.total;
      items = first.cards;
      filterPanel.hidden = false;
      root.querySelector('[data-oo-sort-submit]').hidden = true;
      sortSelect.addEventListener('change', function () { sortForm.requestSubmit(); });
      sortForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
      Object.keys(controls).forEach(function (key) {
        controls[key].addEventListener(key === 'q' ? 'input' : 'change', function () { render(true); });
      });
      root.querySelectorAll('[data-oo-reset]').forEach(function (button) {
        button.addEventListener('click', function () {
          keys.forEach(function (key) { if (key === 'available') controls[key].checked = false; else controls[key].value = ''; });
          render(true);
          controls.q.focus();
        });
      });
      retry.addEventListener('click', function () { loadAll(true); });
      loadAll(false);
    } catch (error) {
      // Keep the original product grid, native sort and pagination usable if enhancement fails.
      filterPanel.hidden = true;
      root.querySelector('[data-oo-sort-submit]').hidden = false;
    }
  }

  return { normalize: normalize, matches: matches, sectionURL: sectionURL, completeCatalog: completeCatalog, mount: mount };
});
